module.exports = __webpack_public_path__ + "media/images/countryrect/sa-f0824a69e3f80ee98ec1887da4fc6f12.svg";